// frontend/src/pages/teacher/AssignmentListPage.js (نسخه اصلاح شده)

import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
// ✅ FaEye تغییر کاربری می‌دهد
import { FaPlus, FaEye, FaPen, FaTrash, FaSearch, FaSpinner, FaTasks } from 'react-icons/fa'; 
import '../../assets/styles/global.css';

const AssignmentListPage = () => {
    const navigate = useNavigate();
    const [assignments, setAssignments] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAssignments = async () => {
            try {
                // ✅ این API باید فیلد lesson_title را برگرداند (که در سریالایزر شما هست)
                const response = await axios.get(`${API_BASE_URL}/core/teacher/assignments/`, getAuthHeaders());
                setAssignments(response.data);
            } catch (err) {
                setError("خطا در دریافت اطلاعات. لطفاً اتصال خود را بررسی کرده و صفحه را رفرش کنید.");
            } finally {
                setLoading(false);
            }
        };
        fetchAssignments();
    }, []);

    const filteredAssignments = useMemo(() =>
        assignments.filter(assignment =>
            assignment.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (assignment.lesson_title && assignment.lesson_title.toLowerCase().includes(searchTerm.toLowerCase()))
        ),
        [assignments, searchTerm]
    );

    const getStatus = (statusText, dueDate) => {
        if (statusText === 'Graded') {
            return { text: "نمره داده شده", className: "status-active" };
        }
        if (new Date(dueDate) < new Date()) {
            return { text: "مهلت تمام شده", className: "status-expired" };
        }
        return { text: "فعال", className: "status-pending" };
    };

    const renderTableBody = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan="6" className="text-center">
                        <FaSpinner className="spinner" style={{ fontSize: '2rem', margin: '20px' }} />
                    </td>
                </tr>
            );
        }

        if (error) {
            return <tr><td colSpan="6" className="text-center alert alert-danger">{error}</td></tr>;
        }

        if (filteredAssignments.length === 0) {
            return <tr><td colSpan="6" className="text-center">هیچ تکلیفی یافت نشد.</td></tr>;
        }

        return filteredAssignments.map(assignment => {
            const status = getStatus(assignment.status, assignment.due_date);
            return (
                <tr key={assignment.id}>
                    <td>{assignment.title}</td>
                    <td>{assignment.lesson_title || 'درس نامشخص'}</td> {/* ✅ استفاده از lesson_title */}
                    <td>{new Date(assignment.due_date).toLocaleString('fa-IR')}</td>
                    <td>{assignment.max_score}</td>
                    <td><span className={`status-badge ${status.className}`}>{status.text}</span></td>
                    <td>
                        <div className="action-buttons">
                            {/* ✅✅✅ دکمه مشاهده (FaEye) اکنون به صفحه لیست پاسخ‌ها می‌رود */}
                            <button 
                                className="action-btn btn-view" 
                                title="مشاهده پاسخ‌های ارسالی"
                                onClick={() => navigate(`/teacher/assignment/${assignment.id}/submissions`)}
                            >
                                <FaEye />
                            </button>
                            <button className="action-btn btn-edit" title="ویرایش"><FaPen /></button>
                            <button className="action-btn btn-delete" title="حذف"><FaTrash /></button>
                        </div>
                    </td>
                </tr>
            );
        });
    };

    return (
        <div className="page-container" style={{maxWidth: '1200px'}}> {/* ✅ افزایش عرض صفحه */}
            <div className="page-header">
                <div>
                    <h1><FaTasks /> مدیریت تکالیف</h1> {/* ✅ آیکون هدر */}
                    <p>لیست تکالیف ایجاد شده را مشاهده و مدیریت کنید.</p>
                </div>
                <button className="button button-primary" onClick={() => navigate('/teacher/assignments/create')}>
                    <FaPlus /> ایجاد تکلیف جدید
                </button>
            </div>
            <div className="data-table-container">
                <div className="table-toolbar">
                    <div className="search-box">
                        <FaSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder="جستجو بر اساس عنوان یا نام درس..." // ✅ متن placeholder آپدیت شد
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>عنوان تکلیف</th>
                            <th>درس مرتبط</th> {/* ✅ ستون آپدیت شد */}
                            <th>مهلت ارسال</th>
                            <th>حداکثر نمره</th>
                            <th>وضعیت</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderTableBody()}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AssignmentListPage;